import React from "react";
import { Switch } from "@mui/material";
import { CustomButton, CustomIconButton, icon, IconComponent } from "../../../../../../common/components";
import styles from "./PackageRow.module.css";

export default function PackageRow({ pck, index, onSelectRow, onToggleForceDisplay, isDragging = false }) {
	const { companies, features, forceDisplay, id, internalName, projects } = pck;

	return (
		<div key={id} className={[styles.row, isDragging && styles.dragging].filter(Boolean).join(" ")}>
			<div className={styles.sortColumn}>
				<IconComponent className={styles.dragHandle} color="var(--grey-400)" icon={icon.faGripVertical} />
				<span className={styles.sortNumber}>{index + 1}</span>
			</div>
			<div className={styles.nameColumn}>
				<span>{internalName}</span>
				<CustomIconButton
					btnClassName={styles.editBtn}
					icon={icon.faPen}
					iconColor="var(--grey-400)"
					size="md"
					onClick={() => {
						onSelectRow(pck, "info");
					}}
				/>
			</div>
			<div className={styles.displayedColumn}>
				<Switch
					checked={!!forceDisplay}
					color="primary"
					size="small"
					onChange={() => onToggleForceDisplay(pck)}
				/>
			</div>
			<div>
				<CustomButton
					variant="outlined"
					onClick={() => {
						onSelectRow(pck, "features");
					}}
				>
					{features}
				</CustomButton>
			</div>
			<div>
				<CustomButton
					data-testid="companies"
					variant="outlined"
					onClick={() => {
						onSelectRow(pck, "companies");
					}}
				>
					{companies}
				</CustomButton>
			</div>
			<div>
				<CustomButton
					variant="outlined"
					onClick={() => {
						onSelectRow(pck, "projects");
					}}
				>
					{projects}
				</CustomButton>
			</div>
		</div>
	);
}
